/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */



import BaseObject from "@shared/BaseObject";

export default class NoteItem extends BaseObject{

	title: ?string = null
	text: ?string = null
	// authorId: ?string = null
	// authorName: ?string = null
	lastModified : number = null;


	_changed: boolean = false
	_isEditing: boolean = false
	_editingText: boolean = false

	constructor(){
		super()
		this.createdAt = new Date().getTime()
		this.lastModified = this.createdAt
	}



}
